export default __webpack_public_path__ + "03dba505c45e7ec0c4e1d28926d477b5.webp";